import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faShieldVirus, faServer, faAsterisk } from '@fortawesome/free-solid-svg-icons';
import { faBuromobelexperte } from '@fortawesome/free-brands-svg-icons';

// Main navigation items
export const navbarItems = [
  { name: 'Services', slug: 'services' },
  { name: 'Customers Review', slug: 'customers-review' },
  { name: 'service Area', slug: 'service-area' },
  { name: 'Help', slug: 'help' }
];

// Footer navigation items
export const helpData = [
  { name: 'Customers Review', slug: 'customers-review' },
  { name: 'About', slug: 'about' },
  { name: 'Contact', slug: 'contact' },
  { name: 'FAQs', slug: 'faqs' },
];

export const offerData = [
  { name: 'Services', slug: 'services' },
  { name: 'Refer & Rewards', slug: 'refer-rewards' },
  { name: 'Join Our Team', slug: 'join-team' }
];

export const serviceArea1 = [
  { name: 'Eastern Suburbs', slug: 'eastern-suburbs' },
  { name: 'Inner South', slug: 'inner-south' },
  { name: 'Northern Beaches', slug: 'northern-beaches' },
  { name: 'St. George', slug: 'st-george' },
  { name: 'The Hills District', slug: 'the-hills-district' }
];

export const serviceArea2 = [
  { name: 'Greater Western Sydney', slug: 'greater-western-sydney' },
  { name: 'Inner West', slug: 'inner-west' },
  { name: 'Ryde & Northern Suburbs', slug: 'ryde-northern-suburbs' },
  { name: 'Sutherland Shire', slug: 'sutherland-shire' }
];

// Homepage service categories
export const categories = [
  { 
    slug: '',
    name: 'PC Configuration',
    icon: <FontAwesomeIcon size="2x" color="#000000" icon={faDesktop} />
  },
  { 
    slug: '',
    name: 'Anti-Virus & Networking',
    icon: <FontAwesomeIcon size="2x" color="#000000" icon={faShieldVirus} />
  },
  { 
    slug: '',
    name: 'Data Recovery & Consultation',
    icon: <FontAwesomeIcon size="2x" color="#000000" icon={faServer} />
  },
  { 
    slug: '',
    name: 'Application Development',
    icon: <FontAwesomeIcon size="2x" color="#000000" icon={faBuromobelexperte} />
  },
  { 
    slug: '',
    name: 'Miscellaneous',
    icon: <FontAwesomeIcon size="2x" color="#000000" icon={faAsterisk} />
  }
];